import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { API_BASE } from '../../config/api';
import { FaArrowRight } from 'react-icons/fa';
import './AdminQuoteEdit.css';

const defaultForm = {
  quote_text:
    'الاستشارة الأكاديمية ليست رفاهية، بل أداة ذكية تسبق بها الطالبة غيرها، وتختصر عليها سنوات من المعاناة.',
  quote_author: 'د. نهى الحازمي',
};

const AdminQuoteEdit = () => {
  const navigate = useNavigate();

  const getAuthHeaders = () => {
    const token = localStorage.getItem('adminToken');
    return token ? { Authorization: `Bearer ${token}` } : {};
  };

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState(defaultForm);

  const empty = useMemo(() => defaultForm, []);

  useEffect(() => {
    axios
      .get(`${API_BASE}/api/admin/quote`, { headers: getAuthHeaders() })
      .then((res) => {
        const q = res.data?.quote;
        if (!q) return setForm(empty);
        setForm({
          quote_text: q.quote_text ?? empty.quote_text,
          quote_author: q.quote_author ?? empty.quote_author,
        });
      })
      .catch((err) => {
        console.error('Failed to load quote:', err);
        setForm(empty);
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await axios.put(`${API_BASE}/api/admin/quote`, form, {
        headers: getAuthHeaders(),
      });
      alert('تم حفظ نص الاقتباس بنجاح');
      navigate('/admin');
    } catch (err) {
      alert(err.response?.data?.error || 'فشل حفظ الاقتباس');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="admin-loading">جاري التحميل...</div>;

  return (
    <div className="admin-quote-edit" dir="rtl">
      <div className="admin-quote-edit-header">
        <Link to="/admin" className="back-link">
          <FaArrowRight /> العودة للصفحة الرئيسية
        </Link>
        <h1 className="admin-page-title">تعديل الاقتباس</h1>
      </div>

      <form onSubmit={handleSubmit} className="admin-quote-form">
        <div className="form-row">
          <label>نص الاقتباس</label>
          <textarea
            className="form-input"
            rows={4}
            value={form.quote_text}
            onChange={(e) => handleChange('quote_text', e.target.value)}
            required
          />
        </div>

        <div className="form-row">
          <label>اسم الكاتبة</label>
          <input
            className="form-input"
            type="text"
            value={form.quote_author}
            onChange={(e) => handleChange('quote_author', e.target.value)}
            required
          />
        </div>

        <div className="form-actions">
          <button type="submit" className="admin-btn-primary" disabled={saving}>
            {saving ? 'جاري الحفظ...' : 'حفظ'}
          </button>
          <button
            type="button"
            className="admin-btn-secondary"
            onClick={() => navigate('/admin')}
            disabled={saving}
          >
            إلغاء
          </button>
        </div>
      </form>
    </div>
  );
};

export default AdminQuoteEdit;

